import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    notifications: {
        system: [],
        tickets: [],
        pendingRead: 0
    }
}

export const notificationSlice = createSlice({
    name: 'notifications',
    initialState,
    reducers: {
        setNotifications: (state, { payload }) => {
            state.notifications = payload
        }
    },
    resetStateNotifications: () => initialState
})

export const { setNotifications, resetStateNotifications } = notificationSlice.actions
export default notificationSlice.reducer
